import { useQuery, UseQueryOptions } from 'react-query';
import { BIG_PAGE_SIZE } from 'utils/constants';
import {
  DjangoListResponse,
  ProposalRejectionOptionRole,
  ProposalRejectionOption,
} from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import { proposalRejectionOptionKeys } from './query-keys';

type FetchProposalRejectionOptionProps = {
  role: ProposalRejectionOptionRole;
};

async function fetchProposalRejectionOptions({
  role,
}: FetchProposalRejectionOptionProps) {
  const response = await restFactory.get<
    DjangoListResponse<ProposalRejectionOption>
  >('/dj/api/v1/proposal_rejection_options/', {
    role,
    size: BIG_PAGE_SIZE,
    page: 1,
  });

  return response.results;
}

type UseProposalRejectionOptionsProps = {
  role: ProposalRejectionOptionRole;
} & UseQueryOptions<ProposalRejectionOption[]>;

export function useProposalRejectionOptions({
  role,
  ...queryProps
}: UseProposalRejectionOptionsProps) {
  return useQuery({
    queryKey: proposalRejectionOptionKeys.all,
    queryFn: () => fetchProposalRejectionOptions({ role }),
    ...queryProps,
  });
}
